<template>
  <!-- NOTIFICATIONS -->

  <vs-dropdown  v-if="adminRole=='admin'" vs-custom-content vs-trigger-click class="cursor-pointer" ref="checkit">
   
    <span class="iconify" data-icon="feather:user-plus" data-inline="false" :badge="incidentRequests"></span>
    <feather-icon  icon="VideoIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="incidentRequests" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div  class="notification-top text-center p-2 bg-primary text-white">
        <h5 class="text-white p-2 mb-4">{{incidentRequests}} Incident Requests</h5>
        <p class="opacity-75">App Notifications</p>
      </div>
      <router-link :to="{ path: '/'+ $t('menu.incidents.slug') + '/requested'}" class="text-inherit underline"> 
      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-2
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer"
        @click="closeit">
        <span ><span v-if="incidentRequests" class="bg-primary text-white" 
        style="position: absolute;
        top: 2px;
        left: 280px;
        padding: 5px 9px;
        border-radius: 50%;
        ">{{incidentRequests}}</span>View Incident Requests </span>
      </div>
      </router-link>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {ME_DATA,PENDING_USER,MANAGER_PENDING_USER,INCIDENT_REQUESTS} from '@/graphql'


export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
   pendinguser:'',
   incidentRequests:'',
   adminRole:'',
   meID:'',
      unreadNotifications: [
        {
          index    : 0,
          title    : 'New Message',
          msg      : 'Are your going to meet me tonight?',
          icon     : 'MessageSquareIcon',
          time     : this.randomDate({sec: 10}),
          category : 'primary'
        },
        { index    : 1,
          title    : 'New Order Recieved',
          msg      : 'You got new order of goods.',
          icon     : 'PackageIcon',
          time     : this.randomDate({sec: 40}),
          category : 'success'
        },
        { index    : 2,
          title    : 'Server Limit Reached!',
          msg      : 'Server have 99% CPU usage.',
          icon     : 'AlertOctagonIcon',
          time     : this.randomDate({min: 1}),
          category : 'danger'
        },
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    closeit(){
    this.$refs['checkit'].$el.click()
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate ({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    }
  },
created () {
   this.$apollo
        .query({
          query: ME_DATA,
        })
        .then((response) => {
          this.meID=response.data.me.id
          this.adminRole = response.data.me.roles[0].name
          if(response.data.me.roles[0].name=='admin'){
           this.$apollo
           .query({
             query: INCIDENT_REQUESTS,
           })
         .then(response => {
         this.incidentRequests=response.data.IncidentRequests.counter
      })
      } 
        })
        .catch((error) => {
        });
  },
}

</script>
<style lang="scss">
.w3-badge{border-radius:50%}
.w3-hover-red:hover{color:#fff!important;background-color:#f44336!important}
.w3-hover-green:hover{color:#fff!important;background-color:#4CAF50!important}
</style>

